export default "__VITE_ASSET__BjXn0QQI__"